import { openDb } from 'idb';
import 'indexeddb-getall-shim';

const OfflineStore = (dbName, storeName) => {
  const dbPromise = openDb(dbName, 1, (upgradeDB) => {
    upgradeDB.createObjectStore(storeName);
  });

  return {
    async get(key) {
      const db = await dbPromise;
      return db.transaction(storeName).objectStore(storeName).get(key.toString());
    },
    async set(key, val) {
      const db = await dbPromise;
      const tx = db.transaction(storeName, 'readwrite');
      tx.objectStore(storeName).put(val, key.toString());
      return tx.complete;
    },
    async delete(key) {
      const db = await dbPromise;
      const tx = db.transaction(storeName, 'readwrite');
      tx.objectStore(storeName).delete(key.toString());
      return tx.complete;
    },
    async clear() {
      const db = await dbPromise;
      const tx = db.transaction(storeName, 'readwrite');
      tx.objectStore(storeName).clear();
      return tx.complete;
    },
    async keys() {
      const db = await dbPromise;
      return db.transaction(storeName).objectStore(storeName).getAllKeys();
    },
  };
};

export default OfflineStore;
